import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {setStaticDataInterests, setStaticDataSkills} from "store/reducer/static/reducer";

export function* downloadSkillsSaga() {
    try {
        const response = yield call([api, api.getSkills]);
        yield put(setStaticDataSkills(response));
    } catch (e) {
        //SWALLOW
    }
}
export function* downloadInterestsSaga() {
    try {
        const response = yield call([api, api.getInterests]);
        yield put(setStaticDataInterests(response));
    } catch (e) {
        //SWALLOW
    }
}
